import { SpeakingMonitoringReason } from 'api';

export const getSpeakingMonitoringReasonName = (reasonType: SpeakingMonitoringReason): string => {
  const reasonTypeNames: Record<SpeakingMonitoringReason, string> = {
    [SpeakingMonitoringReason.PsnMonitoring]: 'PSN Monitoring',
    [SpeakingMonitoringReason.Eor]: 'EOR',
    [SpeakingMonitoringReason.ThirdMarkedJp]: '3rd-marked JP',
    [SpeakingMonitoringReason.FollowUpMonitoring]: 'Follow-up monitoring',
    [SpeakingMonitoringReason.Other]: 'Other',
    [SpeakingMonitoringReason.PsnRequiredMonitoring]: 'PSN Required Monitoring',
    [SpeakingMonitoringReason.PsnAdditionalMonitoring]: 'PSN Additional Monitoring',
  };
  return reasonTypeNames[reasonType] ?? '-';
};
